import { render, staticRenderFns } from "./LandingPageDisplayWidget.vue?vue&type=template&id=48e5d9b2&scoped=true&"
import script from "./LandingPageDisplayWidget.vue?vue&type=script&lang=js&"
export * from "./LandingPageDisplayWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e5d9b2",
  null
  
)

export default component.exports